import React, { useState, FC, useDeferredValue, useMemo } from 'react';
import { Box, TextFieldSize, IconSize, Text } from '@bechtel/gds';
import { ProgressWeld } from './progress-weld';
import { BoxStyled, EmptyStatusContainer, EmptyTextContainer, SearchFieldComponentStyled } from './styled';
import { CaddyWelderDetail } from './caddy-welder-detail';
import { t, Trans } from '@lingui/macro';
// @ts-ignore: tsc declarations not recognising types/index.d.ts
import { ReactComponent as EmptyRodIcon } from '@bechtel/client-assets/dist/images/empty-rod-detail.svg';
import { CrewMember, RodRequestCaddy, RodRequestCaddyStatusCode } from '@bechtel/types';
import { filter, includes, get, map } from 'lodash';
import { ProgressDetail, RodRequestProgressWeld } from '../types';
interface IssuedCaddiesProps {
  caddies: RodRequestCaddy[];
  welders: CrewMember[];
  requestNumber: string;
  rodRequestProgressWeld: RodRequestProgressWeld[];
}

export const IssuedCaddy: FC<IssuedCaddiesProps> = ({ caddies, welders, requestNumber, rodRequestProgressWeld }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const issuedCaddies = filter(caddies, (caddy) =>
    includes([RodRequestCaddyStatusCode.ISSUED, RodRequestCaddyStatusCode.RETURNED], caddy.currentStatusI18n)
  );
  const debouncedSearchQuery = useDeferredValue(searchQuery?.trim());
  const weldersWithIssuedCaddies = useMemo(() => {
    const weldersWithCaddies = {};
    for (const caddy of caddies) {
      for (const welder of caddy.stencils) {
        weldersWithCaddies[welder.id] = {
          totalCaddies: get(weldersWithCaddies, [welder.id, 'totalCaddies'], 0) + 1,
          returnedCaddies:
            get(weldersWithCaddies, [welder.id, 'returnedCaddies'], 0) + caddy.currentStatusI18n ===
            RodRequestCaddyStatusCode.RETURNED
              ? 1
              : 0,
          welder: welder,
        };
      }
    }
    return weldersWithCaddies;
  }, [caddies]);

  return (
    <>
      {issuedCaddies?.length ? (
        <Box css={{ height: '100%' }}>
          <BoxStyled>
            <Box flexGrow={{ sm: 'initial' }} data-testid="caddy-welder-search-container">
              <SearchFieldComponentStyled
                size={TextFieldSize.LARGE}
                iconSize={IconSize.MEDIUM}
                placeholder={t`Search Caddy/Welder`}
                type="search"
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                }}
                value={searchQuery}
              />
            </Box>
            <CaddyWelderDetail caddies={caddies} welders={welders} searchQuery={debouncedSearchQuery} />
          </BoxStyled>
          <Box
            p={{ sm: '500' }}
            flexDirection={{ sm: 'column' }}
            flexGrow={{ sm: 1 }}
            data-testid="caddy-details-container"
            css={{ overflowY: 'auto', height: 'calc(100vh - 145px) ' }}
          >
            {map(weldersWithIssuedCaddies, (progressDetail: ProgressDetail) => (
              <ProgressWeld
                progressDetail={progressDetail}
                key={progressDetail.welder.id}
                requestNumber={requestNumber}
                rodRequestProgressWeld={rodRequestProgressWeld}
              />
            ))}
          </Box>
        </Box>
      ) : (
        <EmptyStatusContainer>
          <EmptyRodIcon style={{ width: '219.997px', height: '179.764px' }} />
          <EmptyTextContainer>
            <Text size="400" family="graphik">
              <Trans>Please issue caddies to manage and proceed further.</Trans>
            </Text>
          </EmptyTextContainer>
        </EmptyStatusContainer>
      )}
    </>
  );
};
